import React, { useState, useEffect } from 'react';
import commonStyles from './Deployment.module.css';
import styles from './ManualDeployment.module.css';
import EM_API from 'common-ui-components/components/utils/API';
import DevicesIcon from '../../icons/devices-icon.svg';
import WindowsIcon from '../../icons/windows.svg';
import MacIcon from '../../icons/mac.svg';
import LinuxIcon from '../../icons/linux.svg';
import copyIcon from 'common-ui-components/components/icons/copy.svg';
import tickIcon from './tick.svg';
import Button from 'common-ui-components/components/button';
import { Input } from 'common-ui-components/components/input';
import {useRestrictionChecker } from 'common-ui-components/components/restrictionUI/RestrictionChecker';
import {
  API_URL,
  PRODUCT_ID,
  PRODUCT_CONTEXT,
} from '../../../../common-ui-components/components/utils/Config';
import { getCustomerIdFromCookies } from 'common-ui-components/accounts/framework/AuthTokenHandler';

function onButtonClicked(element) {
  element.onClick();
}

const ManualDeployment = ({ asModalChild }) => {
  /*user management*/
  const { checkRestriction } = useRestrictionChecker();
  const isVerified = window.localStorage.getItem("IsAccountVerified");
  const canViewDepLink =
    !checkRestriction('DEPLOYMENT_LINK_VIEW', true) && isVerified;
  const [deploymentLink, setDeploymentLink] = useState('');

  // Updated buttonsProps to include agentType and pass the setDownloadingAgent function
  const buttonsProps = [
    {
      label: 'Windows',
      imgSrc: WindowsIcon,
      agentType: 'WINDOWS_MAIN',
      onClick: () => {
        window.location.assign(
          API_URL +
            '/devices/agent/WINDOWS_MAIN/download?productId=' +
            PRODUCT_ID,
        );
      },
    },
    {
      label: 'Mac',
      imgSrc: MacIcon,
      agentType: 'MAC_MAIN',
      onClick: () => {
        window.location.assign(
          API_URL + '/devices/agent/MAC_MAIN/download?productId=' + PRODUCT_ID,
        );
      },
    },
    {
      label: 'Linux',
      imgSrc: LinuxIcon,
      agentType: 'LINUX_MAIN',
      onClick: () => {
        window.location.assign(
          API_URL +
            '/devices/agent/LINUX_MAIN/download?productId=' +
            PRODUCT_ID,
        );
      },
    },
  ];

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchDeploymentLink = async () => {
      try {
        // Assuming res.body.downloadKey is correct
        const res = await EM_API.get(`devices/agent/getDownloadKey?customerId=${getCustomerIdFromCookies()}`);
        if (res.status.code === 200) {
          setDeploymentLink(
            `${window.location.origin}/${PRODUCT_CONTEXT}/agent-download/links?apiKey=${res.body.downloadKey}`,
          );
        } else if (res.status.code === 400) setDeploymentLink('Not Available');
      } catch (error) {
        console.error('Error fetching deployment link:', error);
      }
    };

    fetchDeploymentLink();
  }, []);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(`${deploymentLink}`)
      .then(() => {
        setCopied(true);
      })
      .catch((err) => console.error('Failed to copy:', err));
  };

  // Reset the copied state after a short delay
  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  return (
    <div className={styles.ManualDeployment}>
      <h4 className={commonStyles.deploymentType}>Manual Deployment</h4>
      <p className={commonStyles.deploymentTypeDescription}>
        Install the agent on your devices to manage remotely.
      </p>
      <div className={styles.ManualDeploymentContent}>
        {!asModalChild && (
          <div className={styles.devicesIconContainer}>
            <img src={DevicesIcon} alt='devices' />
          </div>
        )}
        <div
          className={styles.downloadAgentAndDeployment}
          style={asModalChild ? { flex: 1 } : {}}
        >
          <div className={styles.downloadAgent}>
            <h4 className={commonStyles.download}>Download Agent</h4>
            <span className={commonStyles.platformSelect}>
              Select the agent based on the platform
            </span>
            <div className={commonStyles.btnGrp}>
              {buttonsProps.map((element, index) => {
                return (
                  <Button
                    className={commonStyles.btn}
                    key={element.label}
                    onClick={() => {
                      onButtonClicked(element);
                    }}
                  >
                    <img
                      src={element.imgSrc}
                      alt={element.label}
                      width={13}
                      height={13}
                    />
                    <span>{element.label}</span>
                  </Button>
                );
              })}
            </div>
          </div>

          {canViewDepLink && (
            <div className={styles.deployment}>
              <span className={styles.deploymentLink}>Deployment link</span>
              <div className={styles.inputContainer}>
                <Input
                className={styles.input}
                  wrapperProps={{
                    style: {
                      margin: 0,
                    },
                  }}
                  readOnly
                  value={`${deploymentLink}` || 'Fetching...'}
                />
                {!copied ? (
                  <div
                    onClick={copyToClipboard}
                    className={styles.copyButtonContainer}
                  >
                    <Button style={{ display: 'contents' }}>
                      <img src={copyIcon} alt='copy' width={18} height={18} />
                    </Button>
                  </div>
                ) : (
                  <div className={styles.copyButtonContainer}>
                    <Button style={{ display: 'contents' }}>
                      <img src={tickIcon} alt='tick' />
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManualDeployment;